import {createRouter, createWebHistory} from 'vue-router'
import store from "@/store";
import axios from 'axios';

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// =========================================================================
// 新增：解决跨标签页的登录状态同步问题
// =========================================================================
const SYNC_KEY = 'GLOBAL_MEMBER_STATE';

const initMemberFromLocal = () => {
    const localMemberState = localStorage.getItem(SYNC_KEY);
    if (localMemberState) {
        try {
            const parsedMember = JSON.parse(localMemberState);
            if (parsedMember && parsedMember.token) {
                store.replaceState(Object.assign({}, store.state, { member: parsedMember }));
            }
        } catch (e) {
            console.error("跨标签状态同步解析失败", e);
        }
    }
};
initMemberFromLocal();

store.subscribe((mutation, state) => {
    if (state.member && state.member.token) {
        localStorage.setItem(SYNC_KEY, JSON.stringify(state.member));
    } else {
        localStorage.removeItem(SYNC_KEY);
    }
});

window.addEventListener('storage', (event) => {
    if (event.key === SYNC_KEY) {
        if (event.newValue) {
            try {
                const parsedMember = JSON.parse(event.newValue);
                store.replaceState(Object.assign({}, store.state, { member: parsedMember }));
            } catch (e) {
                console.warn("跨标签状态同步解析失败", e);
            }
        } else {
            store.replaceState(Object.assign({}, store.state, { member: {} }));
        }
    }
});
// =========================================================================

const routes = [
    {
        path: '/login',
        component: () => import('../views/NlsLogin.vue')
    },
    {
        path: '/register',
        component: () => import('../views/NlsRegister.vue')
    },
    {
        path: '/reset',
        component: () => import('../views/NlsReset.vue')
    },
    {
        path: '/',
        component: () => import('../views/NlsMain.vue'),
        children: [
            {
                path: 'voice',
                component: () => import('../views/main/FileTrans.vue'),
            },
            {
                path: 'voice/filetrans',
                component: () => import('../views/main/FileTrans.vue'),
                meta: {
                    title: '会议录音高精度转文字_长视频自动提取字幕工具',
                    description: '支持长达数小时的超大音视频文件一键提取文字。搭载最新一代ASR识别模型，针对主流方言优化，识别率高达98%，支持自动提取并匹配字幕时间轴。'
                }
            },
            {
                path: 'voice/videotrans',
                component: () => import('../views/main/FileTrans.vue'),
                meta: {
                    title: '视频人声与伴奏分离提取_多轨智能剥离工具',
                    description: '采用先进的多轨声学剥离技术，即使在强噪或复杂BGM环境下也能精准分离人声。支持单独下载纯净干声轨和无损伴奏轨，为影视混剪二创提供绝佳素材。'
                }
            },
            {
                path: '/voice/resume/ai-resume',
                name: 'AIResumeGenerate',
                component: () => import('@/views/main/AIResumeGenerate2.vue'),
                meta: { title: 'AI智能简历生成' }
            },
            {
                path: '/voice/ai-comic',
                name: 'AiComic',
                component: () => import('@/views/main/AiComic.vue'),
                meta: { title: 'AI漫画' }
            },
            {
                path: 'voice/batch-process',
                component: () => import('../views/batchprocess/BatchProcess.vue'),
            },
            {
                path: 'voice/translation',
                component: () => import('../views/main/Translation.vue'),
                meta: {
                    title: '音频跨语种翻译_克隆原发音人音色的AI语音翻译软件',
                    description: '打破语言障碍，一键实现源语言到目标语言的高精度转换。不仅提供精准文本翻译，更能高度还原并完美克隆原说话人音色。'
                }
            },
            {
                path: 'voice/video-translation',
                component: () => import('../views/main/Translation.vue'),
                meta: {
                    title: '视频多语种翻译与断句匹配_AI视频本地化工具',
                    description: '专为视频出海打造的跨语种翻译引擎，支持长视频精准翻译、自动断句匹配与原声克隆，实现跨国语言的高精度转换与配音还原。'
                }
            },
            {
                path: 'voice/tts',
                redirect: '/voice/tts/text',
            },
            {
                path: 'voice/tts/text',
                component: () => import('../views/main/TTS.vue'),
                meta: {
                    title: '文字转真人语音_100+超拟真情感音色AI配音工具',
                    description: '输入文本极速转化为自然流畅的真人语音，内置涵盖直播、方言、外语及治愈童声等100+款超拟真AI发音人，满足全场景图文配音需求。'
                }
            },
            {
                path: 'voice/tts/file',
                component: () => import('../views/main/TTS.vue'),
                meta: {
                    title: '长文档一键转语音_有声书与长篇文案自动配音软件',
                    description: '支持上传文档文件直接转化为高质量语音，搭载先进的声学模型，发音连贯流畅，完美契合长篇文案、播客及有声小说制作。'
                }
            },
            {
                path: 'voice/tts/multi',
                component: () => import('../views/main/TTS.vue'),
                meta: {
                    title: '复杂场景多人配音_支持多角色对话的智能语音合成',
                    description: '突破单一口播限制，支持复杂场景下的多角色对话配音。为您的小说或广播剧赋予不同角色的独特声线，一人即可完成高质量多人配音。'
                }
            },
            {
                path: 'voice/voiceClone',
                component: () => import('../views/main/VoiceClone.vue'),
                meta: {
                    title: '怎么用AI克隆自己的声音_高保真数字分身克隆工具',
                    description: '星朗智能语音提供极逼真的AI声音克隆引擎。仅需5至10秒纯净干声即可深度解析音色基因，连细微的呼吸声、停顿和情感起伏都能高度还原。'
                }
            },
            {
                path: 'voice/voiceDesign',
                component: () => import('../views/main/VoiceDesign.vue'),
                meta: {
                    title: '从零打造独创虚拟音色_精细化AI声音设计与参数调节',
                    description: '独创的声音设计引擎，允许精细化调节音高、语速、情感张力甚至是共鸣腔特性。通过提示词与多维参数，生成世界上独一无二的专属虚拟声线。'
                }
            },
            {
                path: 'voice/voiceTransform/video',
                component: () => import('../views/main/VoiceTransform.vue'),
                meta: {
                    title: '视频音色替换_无损人声变声与平滑转换软件',
                    description: '无损剥离并替换原有音视频中的人声，先进的情感保留算法完美留存原语速与情感波动，实现毫无违和感的平滑声音转换。'
                }
            },
            {
                path: 'voice/voiceTransform/audio',
                component: () => import('../views/main/VoiceTransform.vue'),
                meta: {
                    title: '音频无损音色替换_保留原语速与情感的变声工具',
                    description: '智能无损剥离并替换音频文件中的人声，先进的情感保留算法完美留存原发音人的语速与情感波动，实现高保真的平滑人声转换。'
                }
            },
            {
                path: 'voice/audio-extract',
                component: () => import('../views/main/AudioExtract.vue'),
                meta: {
                    title: '复杂背景音人声分离_精准提取纯净干声与伴奏工具',
                    description: '采用先进的多轨声学剥离技术，即使在强噪或复杂BGM环境下也能精准分离人声。支持单独提取纯净干声朗读与无损高质量伴奏音乐。'
                }
            },
            {
                path: 'video/lip-sync',
                component: () => import('../views/main/JimengLipSync.vue'),
                meta: {
                    title: '人物图片怎么开口说话_视觉驱动AI对口型视频制作工具',
                    description: '集成顶尖的视觉驱动算法，不仅能克隆音色，更能让静态照片或视频人物的面部肌肉与新配音严丝合缝，彻底解决跨境出海视频常见的音画错位问题。'
                }
            },
            {
                path: 'voice/order-info',
                component: () => import('../views/main/OrderInfo.vue'),
            },
            {
                path: 'voice/fee-demonstration',
                component: () => import('../views/main/FeeDemonstration.vue'),
            },
            {
                path: 'voice/problems-answer',
                component: () => import('../views/main/ProblemsAnswer.vue'),
            },
            {
                path: 'voice/update-log',
                name: 'UpdateLog',
                component: () => import('../views/main/UpdateLog.vue'),
                meta: { title: '更新日志' }
            },
            {
                path: '',
                name: 'Home',
                // redirect: '/voice/filetrans', // 新增：将根路径重定向到目标路由
                component: () => import('../Home.vue'), // 注释掉原有的组件加载
                meta: { title: '星朗智能语音 - 开启AI声音新纪元' } // 注释掉原有的标题
            },

            {
                path: '/about-us',
                name: 'AboutUs',
                component: () => import('@/views/contact/AboutUs.vue'),
                meta: { title: '关于我们' }
            },
            {
                path: '/contact-us',
                name: 'ContactUs',
                component: () => import('@/views/contact/ContactUs.vue'),
                meta: { title: '联系我们' }
            },
            {
                path: '/advice-feedback',
                name: 'AdviceFeedback',
                component: () => import('@/views/contact/AdviceFeedback.vue'),
                meta: { title: '意见反馈' }
            },
            {
                path: '/business-cooperation',
                name: 'BusinessCooperation',
                component: () => import('@/views/contact/BusinessCooperation.vue'),
                meta: { title: '商业合作' }
            },
            {
                path: '/faq',
                name: 'FAQ',
                component: () => import('@/views/contact/FAQ.vue'),
                meta: { title: '常见问题解答' }
            },

            {
                path: '/blog',
                name: 'BlogList',
                component: () => import('@/views/blog/Blog.vue'),
                meta: { title: '星朗技术博客 - 行业白皮书与技术解析' }
            },
            {
                path: '/blog/',
                redirect: '/blog'
            },
            {
                path: '/blog/:slug',
                name: 'BlogDetail',
                component: () => import('@/views/blog/BlogDetail.vue'),
            },

            {
                path: 'legal-statement',
                name: 'LegalStatement',
                component: () => import('@/views/legal/LegalView.vue'),
                meta: { title: '法律声明', docType: 'legal-statement' }
            },
            {
                path: 'terms-of-use',
                name: 'TermsOfUse',
                component: () => import('@/views/legal/LegalView.vue'),
                meta: { title: '使用条款', docType: 'terms-of-use' }
            },
            {
                path: 'privacy-policy',
                name: 'PrivacyPolicy',
                component: () => import('@/views/legal/LegalView.vue'),
                meta: { title: '隐私政策', docType: 'privacy-policy' }
            },
            {
                path: 'user-agreement',
                name: 'UserAgreement',
                component: () => import('@/views/legal/LegalView.vue'),
                meta: { title: '用户服务协议', docType: 'user-agreement' }
            },
            {
                path: 'children-privacy',
                name: 'ChildrenPrivacy',
                component: () => import('@/views/legal/LegalView.vue'),
                meta: { title: '儿童隐私政策', docType: 'children-privacy' }
            }
        ]
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    NProgress.start();
    if (to.matched.some(function (item) {
        return item.meta.loginRequire
    })) {
        const _member = store.state.member;
        if (!_member.token) {
            next('/login');
        } else {
            next();
        }
    } else {
        next();
    }
});

router.afterEach((to) => {
    NProgress.done();
    if (to.meta && to.meta.title) {
        document.title = `${to.meta.title} - 星朗智能语音`;
    } else {
        document.title = '星朗智能语音 - 智能AI配音与录音转文字平台 | 视频翻译_声音克隆/设计';
    }

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
    }

    if (to.meta && to.meta.description) {
        metaDesc.content = to.meta.description;
    } else {
        metaDesc.content = '星朗智能语音为您提供一站式、高精度的音视频处理解决方案。深度集成语音识别、智能配音、高保真声音克隆与视觉驱动口型同步技术，全面赋能数字内容创作。';
    }

    axios.get('/business/web/visit/record').then(res => {
        const data = res.data;
        if (data && data.success && data.content) {
            window.dispatchEvent(new CustomEvent('update-visit-stats', { detail: data.content }));
        }
    }).catch(e => {
        console.error("记录网站访问量失败", e);
    });
});

export default router